/**
 * The page grid's spacing classes, shared so every section lines up: the
 * centred container with its gutters, section padding, and the gap between a
 * section title and its content.
 */
export const CONTAINER = "max-w-7xl mx-auto px-6 sm:px-12 lg:px-16";
// 64 / 96px each side. Two adjacent sections meet at 192px; a hero (pb-16
// sm:pb-24) meets its first section at the same distance.
export const SECTION_PAD = "py-16 sm:py-24";
export const TITLE_TO_CONTENT = "mt-12 sm:mt-16";
